import React from "react";

export default function PrimaryHeading({ className, children }) {
  return (
    <div className={`public_sans_500 text-2xl text-secondaryTextColor ${className}`}>{children}</div>
  );
}
